export default __webpack_public_path__ + "static/media/9.4db3466b.jpg";